// /patient/labs — lab results grouped by category with status pills.
import React from "react";
import { Link } from "react-router-dom";
import {
  formatShortDate,
  usePatientData,
  useUpcomingAndPast,
} from "./PatientDataContext";
import { MOCK_LABS } from "./patientMockData";

export default function PatientLabs() {
  const { rows } = usePatientData();
  const { past } = useUpcomingAndPast(rows);
  const labDate = formatShortDate(past[0]?.date_ || "2026-05-28");

  return (
    <>
      <div className="pp-page-head">
        <Link to="." className="pp-back-link">‹ Home</Link>
        <h1 className="pp-page-title">Lab results</h1>
        <div className="pp-page-sub">Quest Labs · {labDate}</div>
      </div>

      <div className="pp-card">
        <div className="pp-visit-eyebrow" style={{ marginBottom: 4 }}>
          Summary
        </div>
        <p className="pp-detail-p">
          ✓ Most of your numbers look good. One number is a little low. Tap
          the helper to learn what it means.
        </p>
        <Link to="wizard" className="pp-btn pp-coral pp-btn-compact">
          ✨ Explain these in plain words
        </Link>

        {MOCK_LABS.map((group) => (
          <div key={group.group} className="pp-lab-group">
            <div className="pp-lab-group-h">{group.group}</div>
            {group.items.map((item) => (
              <div key={item.name} className="pp-lab-item">
                <div className="pp-lab-name">{item.name}</div>
                <div className="pp-lab-value">
                  <span className="pp-lab-num">{item.value}</span>
                  {item.unit && <span className="pp-lab-unit">{item.unit}</span>}
                  <span
                    className={`pp-row-pill pp-lab-status ${
                      item.status === "NORMAL"
                        ? "pp-green"
                        : item.status === "A LITTLE HIGH"
                        ? "pp-amber"
                        : "pp-red"
                    }`}
                  >
                    {item.status}
                  </span>
                </div>
                <div className="pp-lab-range">{item.range}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}